import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Clear from '@material-ui/icons/Clear';
import RemoveStripeDialog from '../molecules/RemoveStripeDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(withState('openDelete', 'updateOpenDelete', false));

const button = enhance(
  ({ classes, openDelete, updateOpenDelete, params, onClickAction }) => {
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = paramDelete => {
      updateOpenDelete(false);
      onClickAction(paramDelete);
    };
    return (
      <div>
        <Button color="primary" onClick={() => updateOpenDelete(true)}>
          <Clear className={classes.leftIcon} />
          Remove Stripe
        </Button>
        <RemoveStripeDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={() => deleteAction(params)}
          target="メニュー"
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
